G.ProgressBar = function(x,y,sprite,currentValue,maxValue,offsetX,offsetY) {

	G.Image.call(this,x,y,sprite+'_empty',0,null);

	offsetX = typeof offsetX === 'undefined' ? 0 : offsetX;
	offsetY = typeof offsetY === 'undefined' ? 0 : offsetX;

	this.fill = G.makeImage(offsetX,offsetY,sprite+'_full',0,this);
	this.fillFullWidth = this.fill.width;

	this.fillOverlay = G.makeImage(offsetX,offsetY,sprite+'_full_overlay',this.fill,this);
	this.fillOverlay.alpha = 0;

	this.fill.cropRect = new Phaser.Rectangle(0,0,0,this.fill.height);	
	this.fill.updateCrop();

	this.currentValue = currentValue;
	this.prevCurrentValue = currentValue;

	this.targetValue = currentValue;

	//var used for lerp (so lerp dont stuck, because current value will be rounded)
	this.maxValue = maxValue;

	this.lerpValue = 0.05;

	this.updateBarCrop();

	this.onTargetReached = new Phaser.Signal();
	this.onBarFilled = new Phaser.Signal();

};

G.ProgressBar.prototype = Object.create(G.Image.prototype);

G.ProgressBar.prototype.update = function() {

	if (this.currentValue !== this.targetValue) {
		this.currentValue = G.lerp(this.currentValue,this.targetValue,this.lerpValue,this.maxValue*0.005);
		if (this.currentValue === this.targetValue) {
			this.onTargetReached.dispatch();
		}
	}

	if (this.currentValue !== this.prevCurrentValue) {
		this.updateBarCrop();

		if (this.currentValue === this.maxValue) {
			game.add.tween(this.fillOverlay).to({alpha:1},300,Phaser.Easing.Sinusoidal.InOut,true,0,0,true);
			this.onBarFilled.dispatch();
			if (this.label) {
				game.add.tween(this.label).to({alpha:0},600,Phaser.Easing.Sinusoidal.InOut,true);
			}
		}

		if (this.label) {
			if (Math.floor(this.currentValue) !== Math.floor(this.prevCurrentValue)) {
				console.log('updating label');
				this.label.updateValue(Math.floor(this.currentValue));
			}
		}

	}


	this.prevCurrentValue = this.currentValue;

};

G.ProgressBar.prototype.updateBarCrop = function() {

	var oldCropRectWidth = this.fill.cropRect.width;
	var newCropRectWidth = Math.round(this.fillFullWidth*(this.currentValue/this.maxValue));

	if (oldCropRectWidth !== newCropRectWidth) {
		this.fill.cropRect.width = newCropRectWidth;
		this.fill.updateCrop();
	}

};

G.ProgressBar.prototype.changeCurrentValue = function(newTargetValue,lerpValue) {

	this.targetValue = game.math.clamp(newTargetValue,0,this.maxValue);
	this.lerpValue = lerpValue || this.lerpValue;

};

G.ProgressBar.prototype.increaseCurrentValue = function(amount) {

	this.changeCurrentValue(this.targetValue+(amount || 1));

};

G.ProgressBar.prototype.decreaseCurrentValue = function(amount) {

	this.changeCurrentValue(this.targetValue-(amount || 1)); 

};

G.ProgressBar.prototype.changeValues = function(currentValue,maxValue) {

	this.currentValue = currentValue;
	this.prevCurrentValue = currentValue;
	this.targetValue = currentValue;
	this.maxValue = maxValue;

	if (this.label) {
		this.label.changeValues(currentValue,maxValue);
	}

	this.updateBarCrop();

};

G.ProgressBar.prototype.addLabel = function(labelType,animationOnIncrease) {

	this.label = new G.ProgressBar.Label(G.rl(this.width*0.5),G.rl(this.height*0.5),this.currentValue,this.maxValue,Math.floor(G.rl(this.height)*0.6),G.rl(this.width*0.7),labelType,animationOnIncrease);
	this.add(this.label);

};

//
// label types:
// 0 - current/max
// 1 - 20 left
//
G.ProgressBar.Label = function(x,y,currentValue,maxValue,size,maxWidth,labelType,animationOnIncrease) {

	G.OneLineText.call(this,x,y,'font','',size,maxWidth,0.5,0.5);

	this.labelType = labelType || 0;
	this.labelType1Text = OMT.language.getText('%AMOUNT% left');
	this.currentValue = currentValue;
	this.maxValue = maxValue;
	this.animationOnIncrease = animationOnIncrease || false;

	this.updateValue(this.currentValue,true);
};

G.ProgressBar.Label.prototype = Object.create(G.OneLineText.prototype);

G.ProgressBar.Label.prototype.updateValue = function(newCurrentValue,init) {

	if (!init && Math.min(newCurrentValue,this.maxValue) === this.currentValue) return;

	this.currentValue = newCurrentValue;

	this.updateLabelText();

	if (!init && this.animationOnIncrease) {
		G.stopTweens(this);
		this.scale.setTo(1);
		game.add.tween(this.scale).to({x:1.2,y:1.2},200,Phaser.Easing.Sinusoidal.InOut,true,0,0,true);
	}

};

G.ProgressBar.Label.prototype.changeValues = function(currentValue,maxValue) {

	this.currentValue = currentValue;
	this.maxValue = maxValue;
	this.alpha = this.currentValue < this.maxValue ? 1 : 0;
	this.updateLabelText();

};

G.ProgressBar.Label.prototype.updateLabelText = function() {

	if (this.labelType == 0) {
		this.setText(this.currentValue+'/'+this.maxValue);
	}else {
		this.setText(this.labelType1Text.replace('%AMOUNT%',(this.maxValue-this.currentValue)));
	}

};